import { render, staticRenderFns } from "./WarehouseAdd.vue?vue&type=template&id=6e6d7dd4&scoped=true"
import script from "./WarehouseAdd.vue?vue&type=script&lang=js"
export * from "./WarehouseAdd.vue?vue&type=script&lang=js"
import style0 from "./WarehouseAdd.vue?vue&type=style&index=0&id=6e6d7dd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6d7dd4",
  null
  
)

export default component.exports